export default function PrivacyPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-8 space-y-6 text-[#ddd]" data-testid="privacy-page">
      <h1 className="text-2xl font-bold text-[#FF0000] tracking-wider font-mono">Privacy Policy</h1>
      <p className="text-xs text-[#666]">Last updated: May 2026</p>

      <div className="space-y-4 text-sm leading-relaxed">
        <section>
          <h2 className="text-base font-bold text-[#FF0000]/80 mb-2">1. Information We Collect</h2>
          <p>When you create an account, we collect your email address and name. We also collect usage data such as session duration and feature interactions to improve the service.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#FF0000]/80 mb-2">2. How We Use Information</h2>
          <p>We use your information to provide and maintain MIRRORS, process payments, send service updates, and improve the user experience. We do not sell personal data to third parties.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#FF0000]/80 mb-2">3. Payment Processing</h2>
          <p>Payments are processed securely through Stripe. We do not store credit card numbers on our servers. Stripe's privacy policy applies to payment data.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#FF0000]/80 mb-2">4. Cookies & Local Storage</h2>
          <p>We use HTTP-only cookies for authentication and localStorage for session preferences (listening streak, audio settings). No third-party tracking cookies are used.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#FF0000]/80 mb-2">5. Data Retention</h2>
          <p>Account data is retained while your account is active. You may request deletion of your account and associated data by contacting contact@godmodesound.com.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#FF0000]/80 mb-2">6. Contact</h2>
          <p>For privacy inquiries: <a href="mailto:contact@godmodesound.com" className="text-[#FF0000]/70 underline">contact@godmodesound.com</a></p>
        </section>
      </div>
      <p className="text-[8px] font-mono text-[#666] mt-8">GODMODE LLC</p>
    </div>
  );
}
